"use client";

import { FunctionComponent, PropsWithChildren } from "react";
import { Wrapper } from "./slide.styles";
import { type SliderProps } from "../slider";

export interface SlideProps
    extends Pick<SliderProps, "slidesPerView" | "spaceBetween" | "space" | "slideClass" | "activeSlideClass" | "activeGroupClass"> {
    /**
     * Whether the slide is active or not.
     */
    isActive?: boolean;

    /**
     * Whether the slide is currently in the vieport.
     */
    isInViewport?: boolean;

    /**
     * A callback function which will be fired on click.
     */
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;

    /**
     * Class name of the slide.
     */
    className?: string;
}

export const Slide: FunctionComponent<PropsWithChildren<SlideProps>> = ({
    slideClass,
    activeSlideClass,
    activeGroupClass,
    slidesPerView,
    spaceBetween,
    space,
    className,
    isActive = false,
    isInViewport = false,
    onClick,
    children,
}) => {
    return (
        <Wrapper
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            space={space}
            className={`${slideClass || ""} ${isActive ? activeSlideClass || "" : ""} ${isInViewport ? activeGroupClass || "" : ""} ${
                className || ""
            }`
                .replace(/ {2,}/g, " ")
                .trim()}
            onClick={onClick}
        >
            {children}
        </Wrapper>
    );
};
